import ProductBenefitsSummary from './product-benefits-summary'
import RetirementProductBenefits from 'quick-quote/v2/products/categories/retirement/product-benefits-iretire'

const ProductBenefits = ({
  displayProduct,
  sumAssured,
  basicPremium,
  calculatedPaymentPeriod,
  calculatedCoveragePeriod,
  policyValue,
  benefitSummaryHeader,
}) => {
  return (
    <div id="product-benefits" className="benefit group">
      <ProductBenefitsSummary
        displayProduct={displayProduct}
        sumAssured={sumAssured}
        basicPremium={basicPremium}
        calculatedPaymentPeriod={calculatedPaymentPeriod}
        calculatedCoveragePeriod={calculatedCoveragePeriod}
        policyValue={policyValue}
        benefitSummaryHeader={benefitSummaryHeader}
      />
      <RetirementProductBenefits displayProduct={displayProduct} sumAssured={sumAssured} />
    </div>
  )
}

export default ProductBenefits
